import { PicturePack, PictureDataset } from "@tblabs/storage";
import { Div, RefBool, Button, MultipleFilesInput, Snack, Link } from "@tblabs/truffle";


export class PicsUploader extends Div
{
    private onSuccessfulUpload?: (pictures: PicturePack[]) => void;

    constructor(dataset: PictureDataset)
    {
        super("add-field-box");

        const showUploader = new RefBool(false);

        this.Append(
            new Button("Dodaj zdjęcia")
                .OnClick(async () => showUploader.True())
                .Invisible(showUploader),
            new MultipleFilesInput(async (files: File[]) =>
            {
                try
                {
                    new Snack("Rozpoczęto wysyłanie", files.length + " plików");

                    const uploadedPictures: PicturePack[] = await dataset.Add(files);

                    this.onSuccessfulUpload?.(uploadedPictures);

                    new Snack("Wysyłanie zakończone", "✅ Sukces");
                    showUploader.False();
                }
                catch (ex: any)
                {
                    new Snack("Wysyłanie zakończone", "❌ Błąd: " + ex.message);
                }
            }).Visible(showUploader),
            new Link("×").FontSize(20).Color("red").Bold().CursorPointer().Style(`transform: translate(-16px, -12px);`).OnClick(() => showUploader.False())
                .Visible(showUploader)
        );
    }

    public OnSuccessfulUpload(onSuccessfulUpload: (pictures: PicturePack[]) => void): this
    {
        this.onSuccessfulUpload = onSuccessfulUpload;

        return this;
    }
}
